































































import {
  defineComponent,
  PropType,
  SetupContext,
} from '@nuxtjs/composition-api';
import { Post } from '~/graphql/graphqlOperations';
import { useAppStore } from '~/store/app';
export default defineComponent({
  props: {
    feeds: {
      type: Array as PropType<Post[]>,
      required: true,
    },
  },
  setup(_, _context: SetupContext) {
    const { store } = useAppStore();
    const isSignIn = store.isSignedIn;
    return { isSignIn };
  },
});
